<template>
  <button
    class="tw-flex tw-items-center tw-tracking-normal"
    :class="[
      columnIsSorted ? 'tw-text-primary' : 'tw-text-gray-500',
    ]"
    @click="updateOrderBy"
  >
    <icon-angle-down
      v-if="columnIsSorted"
      class="tw-mr-2 tw-transition-all tw-transform tw-w-4 tw-h-4"
      :class="{
        'tw-rotate-180': !filters.order_by.includes('-'),
      }"
    />
    {{ needToTranslateColumnTitle ? $t(title) : title }}
  </button>
</template>

<script>
export default {
  name: 'AdministrationTableHeaderColumn',
  props: {
    prop: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    sortingEnabled: {
      type: Boolean,
      default: true,
    },
    storePath: {
      type: String,
      required: true,
    },
    filtersStateRelativePath: {
      type: String,
      required: true,
    },
    filtersMutationRelativePath: {
      type: String,
      required: true,
    },
    needToTranslateColumnTitle: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    filters() {
      const pathArray = this.storePath.split('/');
      let stateFragment = this.$store.state;
      pathArray.forEach((path) => {
        stateFragment = stateFragment[path];
      });
      return stateFragment[this.filtersStateRelativePath];
    },
    columnIsSorted() {
      return this.filters.order_by.replace('-', '') === this.prop;
    },
  },

  methods: {
    updateOrderBy() {
      if(!this.sortingEnabled) {
        return;
      }
      const currentFilter = this.filters.order_by;
      const isFilteredByProp = currentFilter.includes(this.prop);

      if (isFilteredByProp) {
        this.updateSortOrder(currentFilter.includes('-'));
        return;
      }

      this.updateSortOrder(true);
    },

    updateSortOrder(isAscending) {
      const sortOrder = isAscending ? this.prop : `-${this.prop}`;
      this.$store.commit(`${this.storePath}/${this.filtersMutationRelativePath}`, {
        field: 'order_by',
        payload: sortOrder,
      });
    },
  },
};
</script>
